// extracted by mini-css-extract-plugin
export var createdDate = "_is-1";
export var divider = "_is-2";
export var headerDivider = "_is-3";
export var messagesCard = "_is-0";
export var messagesContainer = "_is-7";
export var messagesContainerWrapper = "_is-4";
export var pointerCapturingButtonBoxes = "_is-a";
export var showLeftPanelButton = "_is-9";
export var showMoreButton = "_is-c";
export var showMoreButtonContainer = "_is-b";
export var summaryTitle = "_is-6";
export var systemMessageCardWrapper = "_is-d";
export var topButtons = "_is-8";
export var withPadding = "_is-5";